import { useTranslation } from "lib/i18n/translation"

const ExportDataInCSVError = ({}) => {
	const { c } = useTranslation("common")

	return (
		<>
			<h2 className="overlay-title">{c("error-thrown")}</h2>
			<p>{c("export-account-data-error")}</p>
		</>
	)
}

export default ExportDataInCSVError
